import { useRouter } from 'next/router';

export const useGetViewedLocation = () => {
  const router = useRouter();
  if (!router.isReady) return '';
  return typeof router.query?.viewedLocation === 'string' ? router.query?.viewedLocation : '';
};
